import { useState, useEffect, useCallback, useRef } from "react";

const BASE_URL = "https://www.kingsacademy.edu.jo";

const STAFF_DATA = [
  {
    "id": 26090,
    "name": "Olfat Abdelqader",
    "title": "Faculty Member, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Olfat-Abdelqader.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26090",
    "localPhoto": "/photos/Bio_Olfat-Abdelqader.jpg"
  },
  {
    "id": 29190,
    "name": "Sohaib Abdullah",
    "title": "Faculty Member, Math, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Sohaib-Abdullah.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29190",
    "localPhoto": "/photos/Bio_Sohaib-Abdullah.jpg"
  },
  {
    "id": 29207,
    "name": "Walid Abediseid",
    "title": "Faculty Member, Math, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Walid-Abediseid.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29207",
    "localPhoto": "/photos/Bio_Walid-Abediseid.jpg"
  },
  {
    "id": 25486,
    "name": "Hanadi Abihaidar",
    "title": "Alumni Relations Senior Officer and Executive Assistant to the Chief Advancement Officer",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Hanadi-Abi-Haidar.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/25486",
    "localPhoto": "/photos/Bio_Hanadi-Abi-Haidar.jpg"
  },
  {
    "id": 26070,
    "name": "Ali Abu Shukur",
    "title": "Faculty Member, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Ali-Abu-Shukur.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26070",
    "localPhoto": "/photos/Bio_Ali-Abu-Shukur.jpg"
  },
  {
    "id": 23615,
    "name": "Lana Abukhader",
    "title": "Faculty Member, Science, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Lana-AbuKhader.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23615",
    "localPhoto": "/photos/Bio_Lana-AbuKhader.jpg"
  },
  {
    "id": 25792,
    "name": "Sarah Aburahmeh",
    "title": "Faculty Member, French, Department of World Languages",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Sarah-Abu-Rahmeh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/25792",
    "localPhoto": "/photos/Bio_Sarah-Abu-Rahmeh.jpg"
  },
  {
    "id": 29203,
    "name": "Amin Ajlouni",
    "title": "Faculty Member, Chemistry, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Amin-Ajlouni.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29203",
    "localPhoto": "/photos/Bio_Amin-Ajlouni.jpg"
  },
  {
    "id": 23415,
    "name": "Nahid Ajluni",
    "title": "Science Lab Manager, Department of Physical and Life Sciences and Robotics Program Manager",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_nahid-ajluni.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23415",
    "localPhoto": "/photos/bio_nahid-ajluni.jpg"
  },
  {
    "id": 23411,
    "name": "Hanan Al Bqour",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_hanan-al-bqour.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23411",
    "localPhoto": "/photos/bio_hanan-al-bqour.jpg"
  },
  {
    "id": 29196,
    "name": "Georgina Al Dalou",
    "title": "Faculty Member, Math, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Georgina-Al-Dalou.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29196",
    "localPhoto": "/photos/Bio_Georgina-Al-Dalou.jpg"
  },
  {
    "id": 29552,
    "name": "Lina Al Rababah",
    "title": "Faculty Member, Department of World Languages",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Lina-Al-Rababah.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29552",
    "localPhoto": "/photos/Bio_Lina-Al-Rababah.jpg"
  },
  {
    "id": 29204,
    "name": "Zeena Alali",
    "title": "School Counselor",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Zeena-Al-Ali.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29204",
    "localPhoto": "/photos/Bio_Zeena-Al-Ali.jpg"
  },
  {
    "id": 23246,
    "name": "Lana Alansari",
    "title": "Associate Dean of Enrollment Management and Financial Aid",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Lana-Alansari.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23246",
    "localPhoto": "/photos/Bio_Lana-Alansari.jpg"
  },
  {
    "id": 26121,
    "name": "Arwa Alfarah",
    "title": "School Nurse",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Arwa-AlFarah.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26121",
    "localPhoto": "/photos/Bio_Arwa-AlFarah.jpg"
  },
  {
    "id": 28823,
    "name": "Mohammad Alkilani",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Mohammad-AlKilani.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28823",
    "localPhoto": "/photos/Bio_Mohammad-AlKilani.jpg"
  },
  {
    "id": 29211,
    "name": "Thomas Allen",
    "title": "Faculty Member, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Thomas-Allen.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29211",
    "localPhoto": "/photos/Bio_Thomas-Allen.jpg"
  },
  {
    "id": 23382,
    "name": "Rania Al-Natsheh",
    "title": "Faculty Member, Arabic, Department of World Languages",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_rania-al-natsheh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23382",
    "localPhoto": "/photos/bio_rania-al-natsheh.jpg"
  },
  {
    "id": 23467,
    "name": "Mohammad Al-Quraan",
    "title": "Faculty Member, Department of Mathematics and Computational Thinking and Class Dean",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_mohammad-al-quraan.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23467",
    "localPhoto": "/photos/bio_mohammad-al-quraan.jpg"
  },
  {
    "id": 23257,
    "name": "Reem Alsafadi",
    "title": "Health Center Officer",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Reem-Alsafadi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23257",
    "localPhoto": "/photos/Bio_Reem-Alsafadi.jpg"
  },
  {
    "id": 29187,
    "name": "Asma’a Altayeb",
    "title": "Faculty Member, Arabic, Department of CRLA, and Islamic Studies, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Asma'a-Al-Tayeb.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29187",
    "localPhoto": "/photos/Bio_Asma'a-Al-Tayeb.jpg"
  },
  {
    "id": 2859,
    "name": "Fatima Al-Yousef",
    "title": "Electronics Communications Manager",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_fatima-al-yousef.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/2859",
    "localPhoto": "/photos/bio_fatima-al-yousef.jpg"
  },
  {
    "id": 26783,
    "name": "Rami Ashour",
    "title": "Associate Director of University Counseling",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Rami-Ashour.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26783",
    "localPhoto": "/photos/Bio_Rami-Ashour.jpg"
  },
  {
    "id": 29581,
    "name": "Wasim Ayesh",
    "title": "Communications and Publications Director",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Wasim-Ayesh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29581",
    "localPhoto": "/photos/Bio_Wasim-Ayesh.jpg"
  },
  {
    "id": 29621,
    "name": "Louren Badra",
    "title": "Admissions Operations Officer",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Louren-Badra.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29621",
    "localPhoto": "/photos/Bio_Louren-Badra.jpg"
  },
  {
    "id": 23420,
    "name": "Tania Banna",
    "title": "Faculty Member, Music, Department of Visual and Performing Arts and Class Dean",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Tania-Twal-Banna.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23420",
    "localPhoto": "/photos/Bio_Tania-Twal-Banna.jpg"
  },
  {
    "id": 28811,
    "name": "Michael Barraclough",
    "title": "Head of the Upper School",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Michael-Barraclough.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28811",
    "localPhoto": "/photos/Bio_Michael-Barraclough.jpg"
  },
  {
    "id": 29599,
    "name": "Alexandra Bayliss",
    "title": "Teaching Fellow, Spanish, Department of World Languages",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Alexandra-Bayliss.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29599",
    "localPhoto": "/photos/Bio_Alexandra-Bayliss.jpg"
  },
  {
    "id": 28350,
    "name": "Abdelrazzaq Ben Tarif",
    "title": "Head, Arabic, Department of CRLA and Class Dean",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Abdelrazzaq-Bin-Tarif.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28350",
    "localPhoto": "/photos/Bio_Abdelrazzaq-Bin-Tarif.jpg"
  },
  {
    "id": 29188,
    "name": "Madeline Birknes",
    "title": "Teaching Fellow, History, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Madeline-Birknes.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29188",
    "localPhoto": "/photos/Bio_Madeline-Birknes.jpg"
  },
  {
    "id": 29195,
    "name": "Matthew Bryant",
    "title": "Faculty member, History, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Mathttew-Bryant.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29195",
    "localPhoto": "/photos/Bio_Mathttew-Bryant.jpg"
  },
  {
    "id": 26769,
    "name": "Mousa Budair",
    "title": "Chief Financial Officer and Deputy Head of School for Finance and Operations",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Mousa-Budair.png",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26769",
    "localPhoto": "/photos/Bio_Mousa-Budair.png"
  },
  {
    "id": 28806,
    "name": "Laura Burgess",
    "title": "Dean of Enrollment Management",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Laura-Burgess.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28806",
    "localPhoto": "/photos/Bio_Laura-Burgess.jpg"
  },
  {
    "id": 26782,
    "name": "Matthew Burrell",
    "title": "Head, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Matthew-Burrell.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26782",
    "localPhoto": "/photos/Bio_Matthew-Burrell.jpg"
  },
  {
    "id": 23175,
    "name": "Laura Dalou",
    "title": "Senior Human Resources and General Administration Officer",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Laura-Dalou.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23175",
    "localPhoto": "/photos/Bio_Laura-Dalou.jpg"
  },
  {
    "id": 29061,
    "name": "Rand Edilbi",
    "title": "Faculty Member, Fine Arts, Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Rand-Edilbi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29061",
    "localPhoto": "/photos/Bio_Rand-Edilbi.jpg"
  },
  {
    "id": 26780,
    "name": "Hani Elayyan",
    "title": "Faculty Member, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Hani-Elayyan.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26780",
    "localPhoto": "/photos/Bio_Hani-Elayyan.jpg"
  },
  {
    "id": 23364,
    "name": "Wafa'a El-Haddad",
    "title": "Gift Processing and Reporting Manager",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Wafaa-El-Haddad.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23364",
    "localPhoto": "/photos/Bio_Wafaa-El-Haddad.jpg"
  },
  {
    "id": 28814,
    "name": "Sohaib Enizat",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Sohaib-Enizat.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28814",
    "localPhoto": "/photos/Bio_Sohaib-Enizat.jpg"
  },
  {
    "id": 29189,
    "name": "Ahmed Freihat",
    "title": "Faculty Member, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Ahmad-Freihat.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29189",
    "localPhoto": "/photos/Bio_Ahmad-Freihat.jpg"
  },
  {
    "id": 28533,
    "name": "Myrsini Georgila",
    "title": "Faculty Member, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Myrsini-Georgila.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28533",
    "localPhoto": "/photos/Bio_Myrsini-Georgila.jpg"
  },
  {
    "id": 26788,
    "name": "Matthew Gilmore",
    "title": "Faculty Member, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Matthew-Gilmore.png",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26788",
    "localPhoto": "/photos/Bio_Matthew-Gilmore.png"
  },
  {
    "id": 23232,
    "name": "Bara’a Hakouz",
    "title": "Senior Associate Dean of Enrollment and Financial Aid",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_baraa-hakouz.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23232",
    "localPhoto": "/photos/bio_baraa-hakouz.jpg"
  },
  {
    "id": 26724,
    "name": "Selina Halteh",
    "title": "Executive Assistant to the Head of School",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Selina-Halteh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26724",
    "localPhoto": "/photos/Bio_Selina-Halteh.jpg"
  },
  {
    "id": 26752,
    "name": "Hannah Hartshorn",
    "title": "Faculty Member, Learning Center",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Hannah-Hartshorn.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26752",
    "localPhoto": "/photos/Bio_Hannah-Hartshorn.jpg"
  },
  {
    "id": 23268,
    "name": "Shadi Hasweh",
    "title": "Graphic Designer",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Shadi-Hasweh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23268",
    "localPhoto": "/photos/Bio_Shadi-Hasweh.jpg"
  },
  {
    "id": 28815,
    "name": "Christina Hawatmeh",
    "title": "Head, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Christina-Hawatmeh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28815",
    "localPhoto": "/photos/Bio_Christina-Hawatmeh.jpg"
  },
  {
    "id": 26077,
    "name": "Samuel Hennessy",
    "title": "Faculty Member, Digital Music, Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Samuel-Hennessy.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26077",
    "localPhoto": "/photos/Bio_Samuel-Hennessy.jpg"
  },
  {
    "id": 23335,
    "name": "Rola Jaber",
    "title": "Faculty Member, English, Department of CRLA and Class Dean",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_rola-jaber.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23335",
    "localPhoto": "/photos/bio_rola-jaber.jpg"
  },
  {
    "id": 29201,
    "name": "Sara Jaradat",
    "title": "Faculty member, Computer Science, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Sara-Jaradat.JPG",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29201",
    "localPhoto": "/photos/Bio_Sara-Jaradat.JPG"
  },
  {
    "id": 23349,
    "name": "Ethan Jerome",
    "title": "Faculty Member, Department of History, Religion and Society and Director of Arabic Year",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Ethan-Jerome.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23349",
    "localPhoto": "/photos/Bio_Ethan-Jerome.jpg"
  },
  {
    "id": 28531,
    "name": "Nels Jorgensen",
    "title": "Faculty Member, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Nels-Jorgensen.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28531",
    "localPhoto": "/photos/Bio_Nels-Jorgensen.jpg"
  },
  {
    "id": 28820,
    "name": "Shadi Joudeh",
    "title": "Faculty Member, Fine Arts, Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Shadi-Joudeh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28820",
    "localPhoto": "/photos/Bio_Shadi-Joudeh.jpg"
  },
  {
    "id": 23625,
    "name": "Nadine Kaddoumi",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Nadine-Kaddoumi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23625",
    "localPhoto": "/photos/Bio_Nadine-Kaddoumi.jpg"
  },
  {
    "id": 26778,
    "name": "Amira Karyouti",
    "title": "Faculty Member, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Amira-Karyouti.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26778",
    "localPhoto": "/photos/Bio_Amira-Karyouti.jpg"
  },
  {
    "id": 23404,
    "name": "Dima Kayed",
    "title": "Faculty Member, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Dima-Kayed.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23404",
    "localPhoto": "/photos/Bio_Dima-Kayed.jpg"
  },
  {
    "id": 28821,
    "name": "Jeffrey Koch",
    "title": "Faculty Member, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Jeffrey-Koch.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28821",
    "localPhoto": "/photos/Bio_Jeffrey-Koch.jpg"
  },
  {
    "id": 23342,
    "name": "Michael Kowalenko",
    "title": "Head of Athletics and Faculty Member, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_michael-kowalenko.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23342",
    "localPhoto": "/photos/bio_michael-kowalenko.jpg"
  },
  {
    "id": 23373,
    "name": "Michael Kussaim",
    "title": "Associate Dean of Academic Affairs and Faculty Member, Biology, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Michael-Kussaim.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23373",
    "localPhoto": "/photos/Bio_Michael-Kussaim.jpg"
  },
  {
    "id": 29193,
    "name": "Brett Lafave",
    "title": "Faculty Member, Math, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Brett-LaFave.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29193",
    "localPhoto": "/photos/Bio_Brett-LaFave.jpg"
  },
  {
    "id": 28816,
    "name": "Jeromel Lara",
    "title": "Teaching Fellow, Humanities, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Jeromel-Lara.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28816",
    "localPhoto": "/photos/Bio_Jeromel-Lara.jpg"
  },
  {
    "id": 29197,
    "name": "Sharon Lee",
    "title": "Faculty Member, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Sharon-Lee.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29197",
    "localPhoto": "/photos/Bio_Sharon-Lee.jpg"
  },
  {
    "id": 29208,
    "name": "Joanna Levison-Aliyev",
    "title": "Dean of University Counseling",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Joanna-Levison-Aliyev.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29208",
    "localPhoto": "/photos/Bio_Joanna-Levison-Aliyev.jpg"
  },
  {
    "id": 23337,
    "name": "Sara'a Malkawi",
    "title": "Assistant Director for Advancement Operations",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_saraa-malkawi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23337",
    "localPhoto": "/photos/bio_saraa-malkawi.jpg"
  },
  {
    "id": 23444,
    "name": "Tatyana Mansour",
    "title": "Faculty Member, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_tatyana-mansour.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23444",
    "localPhoto": "/photos/bio_tatyana-mansour.jpg"
  },
  {
    "id": 29062,
    "name": "Iman Marto",
    "title": "University Counselor",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Iman-Marto.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29062",
    "localPhoto": "/photos/Bio_Iman-Marto.jpg"
  },
  {
    "id": 23322,
    "name": "Rana Matar",
    "title": "Head, Learning Center",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Rana-Matar.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23322",
    "localPhoto": "/photos/Bio_Rana-Matar.jpg"
  },
  {
    "id": 28812,
    "name": "Shaun Mayor",
    "title": "Head, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio-Shaun-Mayor.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28812",
    "localPhoto": "/photos/Bio-Shaun-Mayor.jpg"
  },
  {
    "id": 28813,
    "name": "Hasim Metin",
    "title": "Faculty Member, Math, Department of Mathematics and Computational Thinking",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Hasim-Metin.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28813",
    "localPhoto": "/photos/Bio_Hasim-Metin.jpg"
  },
  {
    "id": 28540,
    "name": "James Meyer",
    "title": "Dean of Faculty",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_James-Meyer.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28540",
    "localPhoto": "/photos/Bio_James-Meyer.jpg"
  },
  {
    "id": 23394,
    "name": "Muntaha Milhem",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Muntaha-Milhem.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23394",
    "localPhoto": "/photos/Bio_Muntaha-Milhem.jpg"
  },
  {
    "id": 29511,
    "name": "Valeria Mugarra",
    "title": "Teaching Fellow, Spanish, Department of World Languages",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Valeria-Mugarra.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29511",
    "localPhoto": "/photos/Bio_Valeria-Mugarra.jpg"
  },
  {
    "id": 23293,
    "name": "Safa Muhsen",
    "title": "Database and Testing Manager",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Safa-Muhsen.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23293",
    "localPhoto": "/photos/Bio_Safa-Muhsen.jpg"
  },
  {
    "id": 29561,
    "name": "Fuad Naserddin",
    "title": "Medical Doctor",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Fuad-Naserddin.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29561",
    "localPhoto": "/photos/Bio_Fuad-Naserddin.jpg"
  },
  {
    "id": 29205,
    "name": "Manal Nayfeh",
    "title": "University Counselor",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Manal-Nayfeh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29205",
    "localPhoto": "/photos/Bio_Manal-Nayfeh.jpg"
  },
  {
    "id": 29521,
    "name": "Abdalla Nimrawi",
    "title": "Faculty Member, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Abdalla-Nimrawi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29521",
    "localPhoto": "/photos/Bio_Abdalla-Nimrawi.jpg"
  },
  {
    "id": 26075,
    "name": "Nadeen Qubain",
    "title": "Faculty Member, Music, Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Nadeen-Qubain.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26075",
    "localPhoto": "/photos/Bio_Nadeen-Qubain.jpg"
  },
  {
    "id": 25800,
    "name": "Hamzeh Qudah",
    "title": "Dean of Students and Faculty Member, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Hamzeh-Qudah.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/25800",
    "localPhoto": "/photos/Bio_Hamzeh-Qudah.jpg"
  },
  {
    "id": 29192,
    "name": "Ronan Runciman",
    "title": "Head of Physical Education and Co-Curricular Programs, Middle School Dean of Students and Admissions Associate",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Ronan-Runciman.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29192",
    "localPhoto": "/photos/Bio_Ronan-Runciman.jpg"
  },
  {
    "id": 29185,
    "name": "Maymouna Sakho",
    "title": "Interim Head of the Middle School",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Maymouna-Sakho.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29185",
    "localPhoto": "/photos/Bio_Maymouna-Sakho.jpg"
  },
  {
    "id": 23177,
    "name": "Ramiz Samawi",
    "title": "Finance Director",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_ramiz-samawi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23177",
    "localPhoto": "/photos/bio_ramiz-samawi.jpg"
  },
  {
    "id": 2919,
    "name": "Hussam Serdah",
    "title": "Head, Department of Information Technology",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_hussam-serdah.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/2919",
    "localPhoto": "/photos/bio_hussam-serdah.jpg"
  },
  {
    "id": 23369,
    "name": "Lina Shaheen",
    "title": "Faculty Member, Biology, Department of Science, Technology, Engineering and Mathematics",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_lina-shaheen.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23369",
    "localPhoto": "/photos/bio_lina-shaheen.jpg"
  },
  {
    "id": 28819,
    "name": "Olga Shalamai",
    "title": "Faculty Member, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Olga-Shalamai.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28819",
    "localPhoto": "/photos/Bio_Olga-Shalamai.jpg"
  },
  {
    "id": 26069,
    "name": "Anas Shalan",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Anas-AlShalan.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26069",
    "localPhoto": "/photos/Bio_Anas-AlShalan.jpg"
  },
  {
    "id": 29557,
    "name": "Tara Shawwa",
    "title": "Faculty Assistant, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Tara-Shawwa.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29557",
    "localPhoto": "/photos/Bio_Tara-Shawwa.jpg"
  },
  {
    "id": 29199,
    "name": "Hyunwoo Song",
    "title": "Faculty Member, History, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Hyunwoo-Song.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29199",
    "localPhoto": "/photos/Bio_Hyunwoo-Song.jpg"
  },
  {
    "id": 29194,
    "name": "Ben Su",
    "title": "Faculty Member, English, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Ben-Su.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29194",
    "localPhoto": "/photos/Bio_Ben-Su.jpg"
  },
  {
    "id": 29209,
    "name": "Mariam Tawalbeh",
    "title": "Faculty Member, Arabic, Department of CRLA",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Mariam-Tawalbeh.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29209",
    "localPhoto": "/photos/Bio_Mariam-Tawalbeh.jpg"
  },
  {
    "id": 23347,
    "name": "Mayyada Tawasha",
    "title": "Dean of Academic Affairs",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_mayyada-tawasha.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23347",
    "localPhoto": "/photos/bio_mayyada-tawasha.jpg"
  },
  {
    "id": 29191,
    "name": "Nathan Taylor",
    "title": "Director of Health and Wellness",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Nathan-Taylor.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29191",
    "localPhoto": "/photos/Bio_Nathan-Taylor.jpg"
  },
  {
    "id": 26056,
    "name": "Zain Tbaishat",
    "title": "Faculty Member, Department of Physical and Life Sciences and Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Zain-Tbaishat.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26056",
    "localPhoto": "/photos/Bio_Zain-Tbaishat.jpg"
  },
  {
    "id": 26774,
    "name": "Basel Theodory",
    "title": "Head, Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Basel-Theodory.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/26774",
    "localPhoto": "/photos/Bio_Basel-Theodory.jpg"
  },
  {
    "id": 28560,
    "name": "Sofia Tomas Haas",
    "title": "Faculty Member, Spanish, Department of World Languages",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Sofia-Tomas-Haas.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28560",
    "localPhoto": "/photos/Bio_Sofia-Tomas-Haas.jpg"
  },
  {
    "id": 28304,
    "name": "Penny Townsend",
    "title": "Head of School",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Penny-Townsend.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/28304",
    "localPhoto": "/photos/Bio_Penny-Townsend.jpg"
  },
  {
    "id": 23176,
    "name": "Alia Wakileh",
    "title": "Director of External Affairs and Institutional Planning, and Secretary to the Board of Trustees",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Alia-Wakileh.png",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23176",
    "localPhoto": "/photos/Bio_Alia-Wakileh.png"
  },
  {
    "id": 29198,
    "name": "Jarrett Wilde",
    "title": "Faculty Member, Department of History, Religion and Society",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Jarrett-Wilde.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29198",
    "localPhoto": "/photos/Bio_Jarrett-Wilde.jpg"
  },
  {
    "id": 23379,
    "name": "Ryuji Yamaguchi",
    "title": "Dean of Community and Student Engagement and Faculty Member, Dance, Department of Visual and Performing Arts",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_ryuji-yamaguchi.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23379",
    "localPhoto": "/photos/bio_ryuji-yamaguchi.jpg"
  },
  {
    "id": 23409,
    "name": "Nisreen Yaseen",
    "title": "Faculty Member, Learning Center",
    "photo": "https://www.kingsacademy.edu.jo/uploaded//faculty/bio_nisreen-yaseen.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/23409",
    "localPhoto": "/photos/bio_nisreen-yaseen.jpg"
  },
  {
    "id": 29584,
    "name": "Mazin Younis",
    "title": "Observatory Director",
    "photo": "https://www.kingsacademy.edu.jo/uploaded/faculty/Bio_Mazin-Younis.jpg",
    "profileUrl": "https://www.kingsacademy.edu.jo/about/directory/profile/~const-id/29584",
    "localPhoto": "/photos/Bio_Mazin-Younis.jpg"
  }
];

// ============================================================
// GROUPS — 12 per group, A through I
// ============================================================
const GROUP_SIZE = 12;
const GROUPS = [];
for (let i = 0; i < STAFF_DATA.length; i += GROUP_SIZE) {
  const label = String.fromCharCode(65 + GROUPS.length);
  GROUPS.push({ label, members: STAFF_DATA.slice(i, i + GROUP_SIZE) });
}

// ============================================================
// SPACED REPETITION
// ============================================================
function getInitialStats(staff) {
  return Object.fromEntries(staff.map((s) => [s.id, { correct: 0, incorrect: 0, streak: 0, lastSeen: 0 }]));
}

function getWeightedQueue(staff, stats) {
  return [...staff].sort((a, b) => {
    const sa = stats[a.id] || { correct: 0, incorrect: 0, streak: 0, lastSeen: 0 };
    const sb = stats[b.id] || { correct: 0, incorrect: 0, streak: 0, lastSeen: 0 };
    const wa = Math.max(1, 10 - sa.streak * 2 + sa.incorrect * 3 + (sa.lastSeen === 0 ? 5 : 0));
    const wb = Math.max(1, 10 - sb.streak * 2 + sb.incorrect * 3 + (sb.lastSeen === 0 ? 5 : 0));
    return wb - wa;
  });
}

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function getChoices(correct, pool, count = 4) {
  const wrong = shuffle(pool.filter((s) => s.id !== correct.id)).slice(0, count - 1);
  return shuffle([correct, ...wrong]);
}

// ============================================================
// MAIN COMPONENT
// ============================================================
export default function KingsFlashcardGame() {
  const [screen, setScreen] = useState("home"); // home | play
  const [mode, setMode] = useState("face-to-name");
  const [activePool, setActivePool] = useState(STAFF_DATA); // current group being studied
  const [activeGroupLabel, setActiveGroupLabel] = useState("All");
  const [stats, setStats] = useState(() => getInitialStats(STAFF_DATA));
  const [current, setCurrent] = useState(null);
  const [choices, setChoices] = useState([]);
  const [selected, setSelected] = useState(null);
  const [sessionCorrect, setSessionCorrect] = useState(0);
  const [sessionTotal, setSessionTotal] = useState(0);
  const [timeLeft, setTimeLeft] = useState(10);
  const [timerActive, setTimerActive] = useState(false);
  const [imgError, setImgError] = useState({});
  const [typedAnswer, setTypedAnswer] = useState("");
  const [typeResult, setTypeResult] = useState(null); // null | "correct" | "wrong"
  const inputRef = useRef(null);

  const masteredCount = (pool) =>
    pool.filter((s) => (stats[s.id]?.streak || 0) >= 3).length;

  const pickNext = useCallback((pool, currentStats, excludeId) => {
    const q = getWeightedQueue(pool, currentStats);
    return q.find((s) => s.id !== excludeId) || q[0];
  }, []);

  const startGame = useCallback((selectedMode, pool, groupLabel) => {
    setMode(selectedMode);
    setActivePool(pool);
    setActiveGroupLabel(groupLabel);
    setSessionCorrect(0);
    setSessionTotal(0);
    setTypedAnswer("");
    setTypeResult(null);
    const first = getWeightedQueue(pool, stats)[0];
    setCurrent(first);
    setChoices(getChoices(first, pool));
    setSelected(null);
    setScreen("play");
    if (selectedMode === "speed") {
      setTimeLeft(10);
      setTimerActive(true);
    }
  }, [stats]);

  // Timer
  useEffect(() => {
    if (!timerActive || screen !== "play" || mode !== "speed") return;
    if (timeLeft <= 0) { handleAnswer(null); return; }
    const t = setTimeout(() => setTimeLeft((x) => x - 1), 1000);
    return () => clearTimeout(t);
  }, [timerActive, timeLeft, screen, mode]);

  // Focus input in type mode
  useEffect(() => {
    if (screen === "play" && mode === "type-name" && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [screen, mode, current]);

  const advanceCard = useCallback((updatedStats) => {
    const next = pickNext(activePool, updatedStats, current?.id);
    setCurrent(next);
    setChoices(getChoices(next, activePool));
    setSelected(null);
    setTypedAnswer("");
    setTypeResult(null);
    if (mode === "speed") {
      setTimeLeft(10);
      setTimerActive(true);
    }
    if (mode === "type-name" && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 150);
    }
  }, [activePool, current, mode, pickNext]);

  const recordResult = useCallback((isCorrect) => {
    setSessionTotal((t) => t + 1);
    if (isCorrect) setSessionCorrect((c) => c + 1);
    const updatedStats = {
      ...stats,
      [current.id]: {
        correct: (stats[current.id]?.correct || 0) + (isCorrect ? 1 : 0),
        incorrect: (stats[current.id]?.incorrect || 0) + (isCorrect ? 0 : 1),
        streak: isCorrect ? (stats[current.id]?.streak || 0) + 1 : 0,
        lastSeen: Date.now(),
      },
    };
    setStats(updatedStats);
    return updatedStats;
  }, [stats, current]);

  const handleAnswer = useCallback((choice) => {
    if (selected !== null) return;
    setSelected(choice);
    setTimerActive(false);
    const isCorrect = choice && choice.id === current.id;
    const updatedStats = recordResult(isCorrect);
    setTimeout(() => advanceCard(updatedStats), 1500);
  }, [selected, current, recordResult, advanceCard]);

  const handleTypeSubmit = useCallback(() => {
    if (typeResult !== null) return;
    const answer = typedAnswer.trim().toLowerCase();
    const firstName = current.name.split(" ")[0].toLowerCase();
    // Fuzzy: accept if within 1 char edit distance or exact
    const isCorrect = answer === firstName || (answer.length > 2 && firstName.startsWith(answer.slice(0, -1)));
    setTypeResult(isCorrect ? "correct" : "wrong");
    const updatedStats = recordResult(isCorrect);
    setTimeout(() => advanceCard(updatedStats), 1800);
  }, [typedAnswer, typeResult, current, recordResult, advanceCard]);

  const accuracy = sessionTotal > 0 ? Math.round((sessionCorrect / sessionTotal) * 100) : 0;

  // Multi-group selection state
  const [selectedGroups, setSelectedGroups] = useState(new Set());
  const [selectedMode, setSelectedMode] = useState("face-to-name");

  const toggleGroup = (label) => {
    setSelectedGroups((prev) => {
      const next = new Set(prev);
      if (next.has(label)) next.delete(label);
      else next.add(label);
      return next;
    });
  };

  const selectAllGroups = () => setSelectedGroups(new Set(GROUPS.map((g) => g.label)));
  const clearGroups = () => setSelectedGroups(new Set());

  const selectedPool = selectedGroups.size === 0
    ? []
    : GROUPS.filter((g) => selectedGroups.has(g.label)).flatMap((g) => g.members);

  const launchGame = () => {
    if (selectedPool.length === 0) return;
    const label = selectedGroups.size === GROUPS.length
      ? "All"
      : "Groups " + [...selectedGroups].sort().join(", ");
    startGame(selectedMode, selectedPool, label);
  };

  const launchRandom = () => {
    startGame(selectedMode, shuffle(STAFF_DATA).slice(0, 12), "Random 12");
  };

  // ============================================================
  // HOME SCREEN
  // ============================================================
  if (screen === "home") {
    return (
      <div style={S.root}>
        <div style={S.bgPattern} />
        <div style={S.homeWrap}>
          <div style={S.crest}>♔</div>
          <h1 style={S.homeTitle}>King's Academy</h1>
          <p style={S.homeSubtitle}>Faculty & Staff Flashcards</p>

          {/* Overall progress */}
          <div style={S.progressRow}>
            <div style={S.pill}>
              <span style={S.pillNum}>{masteredCount(STAFF_DATA)}</span>
              <span style={S.pillLabel}>/ {STAFF_DATA.length} Mastered</span>
            </div>
            {sessionTotal > 0 && (
              <div style={S.pill}>
                <span style={S.pillNum}>{accuracy}%</span>
                <span style={S.pillLabel}>Accuracy</span>
              </div>
            )}
          </div>

          {/* STEP 1: MODE */}
          <p style={S.sectionLabel}>① Choose a Mode</p>
          <div style={S.modeGrid}>
            {[
              { id: "face-to-name", icon: "👤", label: "Face → Name",     desc: "See photo, pick the name" },
              { id: "name-to-face", icon: "🔤", label: "Name → Face",     desc: "See name, pick the photo" },
              { id: "type-name",    icon: "⌨️",  label: "Type First Name", desc: "See photo, type the first name" },
              { id: "speed",        icon: "⚡",  label: "Speed Round",     desc: "10 seconds per card" },
            ].map((m) => (
              <button key={m.id}
                style={{ ...S.modeCard, ...(selectedMode === m.id ? S.modeCardActive : {}) }}
                onClick={() => setSelectedMode(m.id)}>
                <span style={S.modeIcon}>{m.icon}</span>
                <span style={{ ...S.modeName, color: selectedMode === m.id ? "#0d1b3e" : "#c9a84c" }}>{m.label}</span>
                <span style={{ ...S.modeDesc, color: selectedMode === m.id ? "rgba(13,27,62,0.7)" : "#7a6e5a" }}>{m.desc}</span>
                {selectedMode === m.id && <span style={S.modeCheck}>✓</span>}
              </button>
            ))}
          </div>

          {/* STEP 2: GROUPS */}
          <div style={S.groupHeader}>
            <p style={{ ...S.sectionLabel, margin: 0 }}>② Select Groups</p>
            <div style={S.groupHeaderBtns}>
              <button style={S.selectAllBtn} onClick={selectAllGroups}>All</button>
              <button style={S.selectAllBtn} onClick={clearGroups}>None</button>
            </div>
          </div>

          <div style={S.groupGrid}>
            {GROUPS.map((g) => {
              const isSelected = selectedGroups.has(g.label);
              const mc = masteredCount(g.members);
              return (
                <button key={g.label}
                  style={{ ...S.groupBtn, ...(isSelected ? S.groupBtnSelected : {}) }}
                  onClick={() => toggleGroup(g.label)}>
                  <div style={S.groupBtnTop}>
                    <span style={{ ...S.groupBtnLabel, color: isSelected ? "#0d1b3e" : "#c9a84c" }}>
                      Group {g.label}
                    </span>
                    {isSelected && <span style={S.groupCheck}>✓</span>}
                  </div>
                  <span style={{ ...S.groupBtnSub, color: isSelected ? "rgba(13,27,62,0.7)" : "#7a6e5a" }}>
                    {g.members[0].name.split(" ")[0]} – {g.members[g.members.length - 1].name.split(" ")[0]}
                  </span>
                  <span style={{ ...S.groupBtnMastery, color: isSelected ? "rgba(13,27,62,0.6)" : "#c9a84c" }}>
                    {mc}/{g.members.length} ★
                  </span>
                </button>
              );
            })}
          </div>

          {/* STEP 3: LAUNCH */}
          <div style={S.launchRow}>
            {selectedPool.length > 0 ? (
              <button style={S.launchBtn} onClick={launchGame}>
                <span>▶ Play {selectedPool.length} People</span>
                <span style={S.launchSub}>
                  {selectedGroups.size === GROUPS.length ? "All groups" : "Groups " + [...selectedGroups].sort().join(", ")}
                </span>
              </button>
            ) : (
              <div style={S.launchBtnDisabled}>Select groups above to play</div>
            )}
            <button style={S.randomBtn} onClick={launchRandom}>
              🎲 Random 12
            </button>
          </div>

          {/* Mastery dots */}
          <div style={S.dotGrid}>
            {STAFF_DATA.map((s) => {
              const st = stats[s.id] || {};
              const mastered = (st.streak || 0) >= 3;
              const struggling = (st.incorrect || 0) > (st.correct || 0) && (st.incorrect || 0) > 0;
              return (
                <div key={s.id} title={s.name} style={{
                  ...S.dot,
                  background: mastered ? "#c9a84c" : struggling ? "#c0392b" : "#2c3e6b",
                  opacity: st.lastSeen ? 1 : 0.35,
                }} />
              );
            })}
          </div>
          <p style={S.legend}>
            <span style={{color:"#c9a84c"}}>●</span> Mastered &nbsp;
            <span style={{color:"#c0392b"}}>●</span> Struggling &nbsp;
            <span style={{color:"#2c3e6b",opacity:0.6}}>●</span> Unseen
          </p>
        </div>
      </div>
    );
  }

    // ============================================================
  // PLAY SCREEN
  // ============================================================
  return (
    <div style={S.root}>
      <div style={S.bgPattern} />
      <div style={S.playWrap}>
        {/* Header */}
        <div style={S.playHeader}>
          <button style={S.backBtn} onClick={() => { setScreen("home"); setTimerActive(false); }}>
            ← Home
          </button>
          <div style={S.groupChip}>{activeGroupLabel}</div>
          <div style={S.scoreChip}>{sessionCorrect}/{sessionTotal} · {accuracy}%</div>
          {mode === "speed" && (
            <div style={{ ...S.timerChip, background: timeLeft <= 3 ? "#c0392b" : "#c9a84c" }}>
              {timeLeft}s
            </div>
          )}
        </div>

        {/* Speed bar */}
        {mode === "speed" && (
          <div style={S.timerTrack}>
            <div style={{ ...S.timerFill, width: `${(timeLeft/10)*100}%`, background: timeLeft <= 3 ? "#c0392b" : "#c9a84c", transition: "width 1s linear" }} />
          </div>
        )}

        {/* Card */}
        <div style={S.card}>

          {/* FACE → NAME */}
          {(mode === "face-to-name" || mode === "speed") && (
            <>
              <Photo person={current} imgError={imgError} setImgError={setImgError} size={160} />
              <p style={S.cardHint}>{current?.title?.split(",")[0]}</p>
              <div style={S.choicesGrid}>
                {choices.map((c) => (
                  <button key={c.id} disabled={selected !== null} onClick={() => handleAnswer(c)}
                    style={{ ...S.choiceBtn,
                      ...(selected !== null ? c.id === current.id ? S.choiceCorrect : selected?.id === c.id ? S.choiceWrong : S.choiceFaded : {})
                    }}>
                    {c.name}
                  </button>
                ))}
              </div>
            </>
          )}

          {/* NAME → FACE */}
          {mode === "name-to-face" && (
            <>
              <h2 style={S.namePrompt}>{current?.name}</h2>
              <p style={S.cardHint}>{current?.title?.split(",")[0]}</p>
              <div style={S.photoGrid}>
                {choices.map((c) => (
                  <button key={c.id} disabled={selected !== null} onClick={() => handleAnswer(c)}
                    style={{ ...S.photoChoiceBtn,
                      ...(selected !== null ? c.id === current.id ? S.photoCorrect : selected?.id === c.id ? S.photoWrong : S.photoFaded : {})
                    }}>
                    <Photo person={c} imgError={imgError} setImgError={setImgError} size={90} round={8} />
                    {selected !== null && <span style={S.photoName}>{c.name}</span>}
                  </button>
                ))}
              </div>
            </>
          )}

          {/* TYPE FIRST NAME */}
          {mode === "type-name" && (
            <>
              <Photo person={current} imgError={imgError} setImgError={setImgError} size={160} />
              <p style={S.cardHint}>{current?.title?.split(",")[0]}</p>
              <div style={S.typeWrap}>
                <input
                  ref={inputRef}
                  style={{
                    ...S.typeInput,
                    ...(typeResult === "correct" ? S.typeCorrect : typeResult === "wrong" ? S.typeWrong : {})
                  }}
                  value={typedAnswer}
                  onChange={(e) => setTypedAnswer(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleTypeSubmit()}
                  placeholder="Type first name..."
                  disabled={typeResult !== null}
                  autoComplete="off"
                  spellCheck={false}
                />
                {typeResult === null ? (
                  <button style={S.typeSubmitBtn} onClick={handleTypeSubmit}>→</button>
                ) : (
                  <span style={typeResult === "correct" ? S.typeResultCorrect : S.typeResultWrong}>
                    {typeResult === "correct" ? "✓" : `✗ ${current.name.split(" ")[0]}`}
                  </span>
                )}
              </div>
              <p style={S.typeHint}>Press Enter to submit</p>
            </>
          )}

          {/* Feedback row (multiple choice modes) */}
          {(mode !== "type-name") && selected !== null && (
            <div style={S.feedbackRow}>
              {selected?.id === current.id
                ? <span style={S.fbCorrect}>✓ Correct!</span>
                : <span style={S.fbWrong}>✗ {selected === null ? "Time's up! " : ""}{current.name}</span>
              }
              <span style={S.streakBadge}>🔥 {stats[current.id]?.streak || 0}</span>
            </div>
          )}
        </div>

        {/* Mastery bar */}
        <div style={S.masteryRow}>
          <div style={S.masteryTrack}>
            <div style={{ ...S.masteryFill, width: `${(masteredCount(activePool)/activePool.length)*100}%` }} />
          </div>
          <span style={S.masteryText}>{masteredCount(activePool)}/{activePool.length} mastered</span>
        </div>
      </div>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@400;500;600&display=swap');`}</style>
    </div>
  );
}

// ============================================================
// SUB-COMPONENTS
// ============================================================
function Photo({ person, imgError, setImgError, size = 140, round }) {
  if (!person) return null;
  const src = imgError[person.id]
    ? `https://ui-avatars.com/api/?name=${encodeURIComponent(person.name)}&size=${size*2}&background=2c3e6b&color=c9a84c`
    : (person.localPhoto || person.photo);
  return (
    <div style={{ display:"flex", justifyContent:"center", marginBottom: round ? 0 : 16 }}>
      <img src={src} alt={person.name}
        style={{ width:size, height:size, borderRadius: round ?? "50%", objectFit:"cover", objectPosition:"top",
          border:"3px solid rgba(201,168,76,0.4)", boxShadow:"0 8px 32px rgba(0,0,0,0.4)" }}
        onError={() => setImgError((e) => ({ ...e, [person.id]: true }))}
      />
    </div>
  );
}


// ============================================================
// STYLES
// ============================================================
const S = {
  root: { minHeight:"100vh", background:"#0d1b3e", fontFamily:"'DM Sans', sans-serif", color:"#f0ead6", position:"relative", overflowX:"hidden" },
  bgPattern: { position:"fixed", inset:0, backgroundImage:"radial-gradient(circle at 20% 20%, rgba(201,168,76,0.07) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(44,62,107,0.5) 0%, transparent 50%)", pointerEvents:"none" },

  // HOME
  homeWrap: { maxWidth:640, margin:"0 auto", padding:"40px 20px 80px", textAlign:"center", position:"relative" },
  crest: { fontSize:52, lineHeight:1, marginBottom:10, filter:"drop-shadow(0 0 12px rgba(201,168,76,0.5))" },
  homeTitle: { fontFamily:"'Cormorant Garamond', serif", fontSize:38, fontWeight:700, margin:0, color:"#c9a84c", letterSpacing:"0.03em" },
  homeSubtitle: { fontSize:13, color:"#a89b7a", marginTop:6, marginBottom:28, letterSpacing:"0.12em", textTransform:"uppercase" },
  progressRow: { display:"flex", justifyContent:"center", gap:14, marginBottom:32 },
  pill: { background:"rgba(201,168,76,0.1)", border:"1px solid rgba(201,168,76,0.3)", borderRadius:100, padding:"6px 18px", display:"flex", alignItems:"center", gap:6 },
  pillNum: { fontFamily:"'Cormorant Garamond', serif", fontSize:22, fontWeight:700, color:"#c9a84c" },
  pillLabel: { fontSize:12, color:"#a89b7a" },
  sectionLabel: { fontSize:11, letterSpacing:"0.15em", textTransform:"uppercase", color:"#7a6e5a", marginBottom:12, marginTop:28 },

  modeGrid: { display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8, marginBottom:8 },
  modeCard: { background:"rgba(44,62,107,0.4)", border:"1px solid rgba(201,168,76,0.15)", borderRadius:10, padding:"14px 8px", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:4, transition:"all 0.2s" },
  modeCardHover: { background:"rgba(44,62,107,0.7)", border:"1px solid rgba(201,168,76,0.4)" },
  modeIcon: { fontSize:22 },
  modeName: { fontSize:12, fontWeight:600, color:"#c9a84c", textAlign:"center" },
  modeDesc: { fontSize:10, color:"#7a6e5a", textAlign:"center", lineHeight:1.3 },

  groupHeader: { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12, marginTop:28 },
  groupHeaderBtns: { display:"flex", gap:6 },
  selectAllBtn: { background:"transparent", border:"1px solid rgba(201,168,76,0.3)", borderRadius:6, color:"#c9a84c", padding:"3px 10px", fontSize:11, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" },
  groupGrid: { display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8, marginBottom:16 },
  groupBtn: { width:"100%", background:"rgba(20,34,72,0.7)", border:"2px solid rgba(201,168,76,0.15)", borderRadius:10, padding:"11px 8px", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:3, color:"#f0ead6", transition:"all 0.15s" },
  groupBtnSelected: { background:"#c9a84c", border:"2px solid #c9a84c" },
  groupBtnTop: { display:"flex", alignItems:"center", gap:5 },
  groupBtnLabel: { fontSize:14, fontWeight:600 },
  groupBtnSub: { fontSize:10, textAlign:"center", lineHeight:1.3 },
  groupBtnMastery: { fontSize:10, marginTop:1 },
  groupCheck: { fontSize:11, fontWeight:700, color:"#0d1b3e" },
  launchRow: { display:"flex", gap:10, marginBottom:28 },
  launchBtn: { flex:1, background:"#c9a84c", border:"none", borderRadius:12, padding:"14px 16px", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:3, color:"#0d1b3e", fontWeight:700, fontSize:15, fontFamily:"'DM Sans', sans-serif", transition:"all 0.15s", boxShadow:"0 4px 20px rgba(201,168,76,0.3)" },
  launchBtnDisabled: { flex:1, background:"rgba(44,62,107,0.3)", border:"2px dashed rgba(201,168,76,0.2)", borderRadius:12, padding:"14px 16px", display:"flex", alignItems:"center", justifyContent:"center", color:"#4a4438", fontSize:13 },
  launchSub: { fontSize:11, fontWeight:400, opacity:0.7 },
  randomBtn: { background:"rgba(44,62,107,0.6)", border:"1px solid rgba(201,168,76,0.25)", borderRadius:12, padding:"14px 16px", cursor:"pointer", color:"#c9a84c", fontSize:13, fontWeight:600, fontFamily:"'DM Sans', sans-serif", whiteSpace:"nowrap" },
  modeCardActive: { background:"#c9a84c", border:"1px solid #c9a84c" },
  modeCheck: { fontSize:11, fontWeight:700, color:"#0d1b3e", marginTop:1 },

  dotGrid: { display:"flex", flexWrap:"wrap", gap:5, justifyContent:"center", marginBottom:6 },
  dot: { width:14, height:14, borderRadius:"50%", transition:"all 0.3s" },
  legend: { fontSize:11, color:"#7a6e5a", marginBottom:0 },

  // PLAY
  playWrap: { maxWidth:540, margin:"0 auto", padding:"20px 16px 60px", position:"relative" },
  playHeader: { display:"flex", alignItems:"center", gap:8, marginBottom:12, flexWrap:"wrap" },
  backBtn: { background:"transparent", border:"1px solid rgba(201,168,76,0.3)", borderRadius:8, color:"#c9a84c", padding:"5px 12px", fontSize:13, cursor:"pointer", fontFamily:"'DM Sans', sans-serif" },
  groupChip: { background:"rgba(201,168,76,0.1)", border:"1px solid rgba(201,168,76,0.25)", borderRadius:100, padding:"3px 12px", fontSize:12, color:"#c9a84c" },
  scoreChip: { marginLeft:"auto", background:"rgba(44,62,107,0.6)", border:"1px solid rgba(201,168,76,0.2)", borderRadius:100, padding:"3px 12px", fontSize:12, color:"#c9a84c" },
  timerChip: { borderRadius:100, padding:"4px 12px", fontSize:13, fontWeight:700, color:"#0d1b3e", minWidth:40, textAlign:"center" },
  timerTrack: { height:4, background:"rgba(255,255,255,0.08)", borderRadius:100, marginBottom:16, overflow:"hidden" },
  timerFill: { height:"100%", borderRadius:100 },

  card: { background:"rgba(20,34,72,0.85)", border:"1px solid rgba(201,168,76,0.2)", borderRadius:20, padding:"28px 22px", backdropFilter:"blur(8px)", boxShadow:"0 20px 60px rgba(0,0,0,0.5)" },
  cardHint: { textAlign:"center", fontSize:11, color:"#7a6e5a", textTransform:"uppercase", letterSpacing:"0.1em", margin:"0 0 20px" },
  namePrompt: { fontFamily:"'Cormorant Garamond', serif", fontSize:30, fontWeight:700, textAlign:"center", color:"#c9a84c", margin:"0 0 8px" },

  choicesGrid: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:9 },
  choiceBtn: { background:"rgba(44,62,107,0.5)", border:"1px solid rgba(201,168,76,0.2)", borderRadius:10, color:"#f0ead6", padding:"13px 10px", fontSize:13, cursor:"pointer", fontFamily:"'DM Sans', sans-serif", fontWeight:500, transition:"all 0.15s", textAlign:"center", lineHeight:1.3 },
  choiceCorrect: { background:"rgba(39,174,96,0.25)", border:"1px solid #27ae60", color:"#2ecc71" },
  choiceWrong: { background:"rgba(192,57,43,0.25)", border:"1px solid #c0392b", color:"#e74c3c" },
  choiceFaded: { opacity:0.3 },

  photoGrid: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 },
  photoChoiceBtn: { background:"rgba(44,62,107,0.4)", border:"2px solid rgba(201,168,76,0.15)", borderRadius:10, padding:8, cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:5, transition:"all 0.15s" },
  photoCorrect: { border:"2px solid #27ae60", background:"rgba(39,174,96,0.15)" },
  photoWrong: { border:"2px solid #c0392b", background:"rgba(192,57,43,0.15)" },
  photoFaded: { opacity:0.3 },
  photoName: { fontSize:10, color:"#a89b7a", textAlign:"center" },

  // TYPE MODE
  typeWrap: { display:"flex", gap:10, alignItems:"center", margin:"0 0 8px" },
  typeInput: { flex:1, background:"rgba(44,62,107,0.5)", border:"2px solid rgba(201,168,76,0.3)", borderRadius:10, color:"#f0ead6", padding:"14px 16px", fontSize:18, fontFamily:"'DM Sans', sans-serif", outline:"none", transition:"border 0.2s" },
  typeCorrect: { border:"2px solid #27ae60", background:"rgba(39,174,96,0.15)" },
  typeWrong: { border:"2px solid #c0392b", background:"rgba(192,57,43,0.15)" },
  typeSubmitBtn: { background:"#c9a84c", border:"none", borderRadius:10, color:"#0d1b3e", padding:"14px 18px", fontSize:18, cursor:"pointer", fontWeight:700, fontFamily:"'DM Sans', sans-serif" },
  typeResultCorrect: { fontSize:22, color:"#2ecc71", fontWeight:700 },
  typeResultWrong: { fontSize:14, color:"#e74c3c", fontWeight:600, whiteSpace:"nowrap" },
  typeHint: { fontSize:11, color:"#4a4438", textAlign:"center", margin:0 },

  feedbackRow: { marginTop:18, display:"flex", justifyContent:"space-between", alignItems:"center", padding:"9px 13px", background:"rgba(0,0,0,0.2)", borderRadius:10 },
  fbCorrect: { color:"#2ecc71", fontWeight:600, fontSize:14 },
  fbWrong: { color:"#e74c3c", fontWeight:600, fontSize:13 },
  streakBadge: { fontSize:12, color:"#c9a84c" },

  masteryRow: { display:"flex", alignItems:"center", gap:10, marginTop:16 },
  masteryTrack: { flex:1, height:5, background:"rgba(255,255,255,0.07)", borderRadius:100, overflow:"hidden" },
  masteryFill: { height:"100%", background:"linear-gradient(90deg,#c9a84c,#f5d98b)", borderRadius:100, transition:"width 0.6s ease" },
  masteryText: { fontSize:11, color:"#7a6e5a", whiteSpace:"nowrap" },
};
